var React = require('react');

function AddRoundedIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.34 3.66c-4.879-4.88-12.801-4.88-17.68 0-4.88 4.879-4.88 12.801 0 17.68 4.879 4.88 12.801 4.88 17.68 0 4.88-4.879 4.88-12.83 0-17.68zm-3.162 9.548a1.05 1.05 0 01-.723.3H13.54v3.917c0 .27-.12.542-.302.722a1.05 1.05 0 01-.722.301 1.015 1.015 0 01-1.024-1.023v-3.916H7.576a1.015 1.015 0 01-1.023-1.024c0-.572.452-1.023 1.023-1.023h3.916V7.546c0-.572.452-1.024 1.024-1.024.572 0 1.024.452 1.024 1.024v3.916h3.915c.572 0 1.024.451 1.024 1.023-.03.27-.121.543-.301.723z","fill":"#269C74","fillRule":"evenodd"}));
}

AddRoundedIconInline.defaultProps = {"width":"25","height":"25"};

module.exports = AddRoundedIconInline;

AddRoundedIconInline.default = AddRoundedIconInline;
